import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { Subscriptions } from '@air/api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { getSubscriptionKey } from '~/swr-hooks/subscriptions/useSubscription';
import { getSubscriptionPlanKey } from '~/swr-hooks/subscriptions/useSubscriptionPlan';
import { getWorkspaceAddOnsKey } from '~/swr-hooks/workspaces/addOns/useCurrentWorkspaceAddOns';
import { getCreditStatsKey } from '~/swr-hooks/workspaces/useCreditStats';

/** This hook returns a function that updates the current subscription */
export function useUpdateSubscription() {
  const { currentWorkspace } = useCurrentWorkspace();
  const queryClient = useQueryClient();

  const updateSubscription = useCallback(
    async (...params: Parameters<typeof Subscriptions.updateStripePlan>) => {
      await Subscriptions.updateStripePlan(...params);
      if (currentWorkspace?.id) {
        queryClient.invalidateQueries({ queryKey: getSubscriptionKey(currentWorkspace?.id) });
        queryClient.invalidateQueries({ queryKey: getSubscriptionPlanKey(currentWorkspace?.id) });
        queryClient.invalidateQueries({ queryKey: getWorkspaceAddOnsKey(currentWorkspace?.id) });
        queryClient.invalidateQueries({ queryKey: getCreditStatsKey({ workspaceId: currentWorkspace?.id }) });
      }
    },

    [currentWorkspace?.id, queryClient],
  );

  return {
    updateSubscription,
  };
}
